// extracted by mini-css-extract-plugin
export var button = "_iv-2";
export var card = "_iv-0";
export var closeButtonContainer = "_iv-3";
export var iconContainer = "_iv-1";